import { render, staticRenderFns } from "./AttachmentUpdateDialog.vue?vue&type=template&id=dfbf49a8&scoped=true"
import script from "./AttachmentUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbf49a8",
  null
  
)

export default component.exports